<template lang='pug'>
  div
    v-card-title
      v-text-field(v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details)
    v-data-table(:headers='ip.headers' :must-sort="true" :sort-by="pagination.sortBy" :sort-desc="pagination.descending" :items='ip.items' :single-expand="true" item-key="ipNo" class="elevation-1" :search="search" selectable-key='isSelectable' :show-select="showSelect" checkbox-color="blue" v-model="selectedAttachment")
      template(v-slot:item.ipStatusLabel="{ item }")
        v-chip(label small :color="config.status[item.ipStatusColor].color" style="width:100%;justify-content:space-evenly" text-color="black") {{ item.ipStatusLabel }}
      template(v-slot:item.actions="{ item }")
        LampiranPengawalanView(v-if="item.ipForm == 'BIB-HSE-PPO-F-012-02'" :dialogType="dialogType" :ip="item" :approvalUser="dataUsers" title="Preview")
        router-link(v-if="[1,3].includes(item.ipStatus) && item.ipUser.email == dataUsers.email" :to='{ name: routeName(item.ipForm), params: {id: item._id}}')
          v-icon(small class='mr-2' title='Edit' color="green") edit
                
</template>

<script>
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import UploadBukti from "@/components/UploadBukti.vue";
import LampiranPengawalanView from "@/components/LampiranPengawalanView.vue";
// import MarkFinished from "@/components/MarkFinished.vue";
import { mapState } from 'vuex';
export default {
  name: 'PermitList',
  components: {
    UploadBukti,
    LampiranPengawalanView,
    // MarkFinished,
  },
  props: {
    title: String,
    dialogType: String,
    ip: Object,
    keyword: String
  },
  data() {
    return {
      search: '',
      expanded: [],
      showSelect: true,
      formName: config.FormName,
      config: config.default,
      pagination: {
        sortBy: ["ipNo"],
        descending: [true]
      },
      uploadBukti: false,
      docPelaporan: null,
      inputModal: {},
      selectedAttachment: [],
    };
  },
  mounted() {
    this.search = this.keyword;
    if (!this.dataUsers.group_level.includes('PIC')) {
      this.showSelect = false;
    }
  },
  computed: {
    ...mapState(['dataUsers','API_URL']),
  },
  watch: {
    selectedAttachment(val) {
      this.$emit('selectedAttachment', val);
    }
  },
  methods: {
    routeName(val){
      switch (val) {
        case 'BIB-HSE-PPO-FRM-036-001':
          return 'Edit Izin Kerja Dengan Panas';

        case 'BIB-HSE-PPO-FRM-036-002':
          return 'Edit Izin Kerja Ruang Terbatas';

        case 'BIB-HSE-PPO-FRM-036-003':
          return 'Edit Izin Kerja Di Ketinggian';

        case 'BIB-HSE-PPO-FRM-036-004':
          return 'Edit Izin Kerja Penggalian';

        case 'BIB-HSE-PPO-FRM-036-005':
          return 'Edit Izin Kerja Radioaktif';

        case 'BIB-HSE-PPO-FRM-036-006':
          return 'Edit Izin Kerja Remote Area';

        case 'BIB-HSE-PPO-FRM-036-007':
          return 'Edit Izin Kerja Peledakan';

        case 'BIB-HSE-PPO-F-012-02':
          return 'Edit Lampiran Izin Kerja Pengawalan Unit';
          
        default:
          return ''
      }
    },
    getWITADate: helper.getWITADate,
    download(file) {
      this.$downloadFile(file);
    },
    closeModal: function () {
      this.uploadBukti = false;
      this.inputModal = {};
    },
    openModal(input){
      this.uploadBukti = true;
      this.inputModal  = input;
    },
    getUploadId(){
      return Date.now();
    },
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>